import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AssignedProjectService } from 'pages/daiatari/assigned-projects/service';
import { DaiatariService } from 'pages/daiatari/service';
import { QuoteService } from 'pages/quotes/service';
import { creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(AssignedProjectService, QuoteService, DaiatariService, Router)
export class LinkToQuote {
    constructor(assignedProjectService, quoteService, daiatariService, router) {
        this.assignedProjectService = assignedProjectService;
        this.quoteService = quoteService;
        this.daiatariService = daiatariService;
        this.router = router;

        this.visibleSection = 'quoteList';

        this.columns = [
            { caption: 'Link', cellTemplate: 
                (container, options) => {
                    if (this.links.some(x => x.quoteId == options.data.id)) {
                        return '';
                    }
                    return creatTableButton({ container, containerOptions: options, style: 'primary', label: 'Link', action: () => this.link(options.data.id, options.data.partNumber) }) 
                }
            },
            { dataField: 'partNumber', sortOrder: 'asc', caption: 'Part Number' },
            { dataField: 'plantName', caption: 'Plant' },
            { dataField: 'customerName', caption: 'Customer'},
            { dataField: 'projectNumber' },
            { dataField: 'id', caption: 'QS#' },
            { dataField: 'total' },
        ];
    }

    async activate(params) {
        this.assignedProject = await this.assignedProjectService.getById(params.id);
        this.links = await this.daiatariService.getByAssignedProjectId(params.id);
    }

    link = (quoteId, partNumber) => {
        this.links.push({
            quoteId,
            partNumber,
            ratio: 0
        });

        this.grid.refresh();
    };

    remove (index) {
        this.links.splice(index, 1);
    }

    async save () {
        if (this.links.some(x => x.ratio == 0 || x.ratio == null || x.ratio == '')) {
            toastr.error('All ratios have to be set');
            return;
        }

        this.isRequesting = true;
        try {
            await this.daiatariService.saveAssignedProjectLinks(this.assignedProject.id, this.links);
            toastr.success('Assigned Project links saved successfully');
            this.router.navgiateToRoute('assigned-projects');
        } catch {
            this.isRequesting = false;
        }
        this.isRequesting = false;
    }
}